import WarehouseStock from './WarehouseStock';
import React from 'react';
import { WmsStockInfo } from '../types';

interface StockBadgeProps {
  stockInfo?: WmsStockInfo | null;
}

const StockBadge: React.FC<StockBadgeProps> = ({ stockInfo }) => {
  if (!stockInfo) return null;

  if (!stockInfo.wms_available) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500">
        N/D
      </span>
    );
  }

  const qty = stockInfo.available_quantity ?? 0;

  const color = qty <= 0 ? 'bg-red-100 text-red-800'
    : qty < 5 ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800';

  return (
    <div className="inline-flex flex-col gap-1">
      <span className={`inline-flex self-start items-center px-2 py-0.5 rounded-full text-xs font-medium ${color}`}>
        {qty <= 0 ? 'Esaurito' : `${qty} pz`}
      </span>
      <WarehouseStock stock={stockInfo} />
    </div>
  );
};

export default StockBadge;
